'use strict';

var SystemStatusMarketReoptDirective = function SystemStatusMarketReoptDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-market-reopt.html'),
    controller: 'SystemStatusMarketReoptController',
    link: function link(scope) {
      scope.$on('grid:manual-refresh:system-status-market-reopt', scope.loadData);
      scope.$on('search-criteria:onSearchButtonClick', scope.loadData);
      scope.$on('system-reoptimization-status:cancel', scope.cancelOptimization);
    }
  };
};
SystemStatusMarketReoptDirective.$inject = [];
module.exports = SystemStatusMarketReoptDirective;